// ─── COMPLETE 89-REPORT BHARAT KARIGARI CATALOG DEFINITIONS (PAGES 2 - 13) ────
export const REPORT_MODULES = [
  "All",
  "Dashboard",
  "Sales",
  "Orders",
  "Customers",
  "Sellers",
  "Finance",
  "Catalogue",
  "Inventory",
  "Repair/QC",
  "Shipping",
  "Global Commerce",
  "After Sales",
  "Customer Experience",
  "Analytics",
  "Marketing",
  "Communication",
  "Support",
  "Security",
  "System",
  "CMS",
  "Masters",
];

export const ROLE_ACCESS_PERMISSIONS = {
  "Super Admin": { name: "Super Admin", access: "All reports and system controls", sensitive: true },
  "Operations Admin": { name: "Operations Admin", access: "Orders, sellers, catalogue, inventory, shipping, returns", sensitive: false },
  "Catalogue Manager": { name: "Catalogue Manager", access: "Products, categories, crafts, approvals, SEO/CMS", sensitive: false },
  "Inventory Manager": { name: "Inventory Manager", access: "Inventory, stock ledger, transfers, damage, repair, QC", sensitive: false },
  "Finance Admin": { name: "Finance Admin", access: "Payments, refunds, tax, commission, settlement, payouts, profitability", sensitive: true },
  "Seller Manager": { name: "Seller Manager", access: "Seller, KYC, performance, settlement summaries", sensitive: false },
  "Customer Support": { name: "Customer Support", access: "Customer, orders, tracking, returns, tickets, reviews", sensitive: false },
  "Marketing/CMS": { name: "Marketing/CMS", access: "Collections, promotions, coupons, reviews, CMS, SEO", sensitive: false },
  "Auditor": { name: "Auditor", access: "Read-only reports, audit logs, reconciliations", sensitive: false },
};

export const MASTER_89_REPORTS = [
  // Page 2: 1 to 8
  {
    id: 1,
    key: "executive-dashboard",
    name: "Executive Dashboard Report",
    module: "Dashboard",
    filters: ["Date range", "Currency", "Country", "State", "Seller"],
    columns: ["Sales", "Orders", "Customers", "Active Sellers", "Inventory Value", "Returns", "Refunds", "Payable", "GMV"],
    actions: ["View", "Drill-down", "Export PDF/Excel"],
  },
  {
    id: 2,
    key: "daily-sales",
    name: "Daily Sales Report",
    module: "Sales",
    filters: ["Date", "Seller", "Owner", "Category", "Craft", "Country", "Payment status"],
    columns: ["Order No", "Date/Time", "Seller", "Owner", "Customer", "Subtotal", "Discount", "Tax", "Shipping", "Total", "Payment Status"],
    actions: ["View", "Print", "PDF", "Excel", "CSV"],
  },
  {
    id: 3,
    key: "monthly-sales-summary",
    name: "Monthly Sales Summary",
    module: "Sales",
    filters: ["Month", "Year", "Country", "Currency", "Seller"],
    columns: ["Month", "Orders", "Gross Sales", "Discounts", "Tax", "Shipping", "Refunds", "Net Sales"],
    actions: ["View", "Export", "Print"],
  },
  {
    id: 4,
    key: "product-sales",
    name: "Product Sales Report",
    module: "Sales",
    filters: ["Date", "Product", "SKU", "Category", "Craft", "Seller"],
    columns: ["Product", "SKU", "Seller", "Units Sold", "Gross Sales", "Discount", "Tax", "Net Sales", "Returns"],
    actions: ["View product", "Export"],
  },
  {
    id: 5,
    key: "category-sales",
    name: "Category Sales Report",
    module: "Sales",
    filters: ["Date", "Category", "Craft", "Country"],
    columns: ["Category", "Craft", "Orders", "Units", "Sales", "Discounts", "Returns", "Net Sales"],
    actions: ["Export"],
  },
  {
    id: 6,
    key: "craft-performance",
    name: "Craft Performance Report",
    module: "Sales",
    filters: ["Date", "Craft", "State", "Seller"],
    columns: ["Craft", "Products", "Units Sold", "Sales", "Rating", "Return Rate"],
    actions: ["Export", "Drill-down"],
  },
  {
    id: 7,
    key: "state-region-sales",
    name: "State / Region Sales Report",
    module: "Sales",
    filters: ["Country", "State", "District", "Date"],
    columns: ["Geography", "Orders", "Customers", "Sales", "Average Order Value"],
    actions: ["Map/list", "Export"],
  },
  {
    id: 8,
    key: "country-sales",
    name: "Country Sales Report",
    module: "Global Commerce",
    filters: ["Country", "Currency", "Date"],
    columns: ["Country", "Orders", "Sales", "Shipping", "Tax", "Refunds", "Net Sales"],
    actions: ["Export"],
  },

  // Page 3: 9 to 16
  {
    id: 9,
    key: "order-register",
    name: "Order Register",
    module: "Orders",
    filters: ["Date", "Order status", "Payment status", "Seller", "Customer"],
    columns: ["Order No", "Date", "Customer", "Seller/Sub-order", "Items", "Total", "Payment", "Fulfilment", "Status"],
    actions: ["View", "Invoice", "Export"],
  },
  {
    id: 10,
    key: "multi-vendor-order-split",
    name: "Multi-Vendor Order Split Report",
    module: "Orders",
    filters: ["Date", "Seller", "Owner", "Status"],
    columns: ["Master Order", "Sub-order", "Seller", "Owner", "Items", "Subtotal", "Shipping", "Tax", "Commission", "Payable", "Status"],
    actions: ["Drill-down", "Export"],
  },
  {
    id: 11,
    key: "order-status-report",
    name: "Order Status Report",
    module: "Orders",
    filters: ["Date", "Status", "Seller", "Courier"],
    columns: ["Status", "Order Count", "Amount", "Percentage", "Ageing"],
    actions: ["View orders", "Export"],
  },
  {
    id: 12,
    key: "cancelled-order-report",
    name: "Cancelled Order Report",
    module: "Orders",
    filters: ["Date", "Cancellation reason", "Seller"],
    columns: ["Order", "Customer", "Seller", "Amount", "Reason", "Cancelled By", "Date"],
    actions: ["View", "Export"],
  },
  {
    id: 13,
    key: "abandoned-cart-report",
    name: "Abandoned Cart Report",
    module: "Customer",
    filters: ["Date", "Customer", "Value range"],
    columns: ["Cart ID", "Customer", "Items", "Value", "Created", "Last Activity", "Status"],
    actions: ["View customer", "Export"],
  },
  {
    id: 14,
    key: "customer-registration-report",
    name: "Customer Registration Report",
    module: "Customers",
    filters: ["Date", "Country", "State", "Status"],
    columns: ["Customer ID", "Name", "Email", "Mobile", "Location", "Registration Date", "Status"],
    actions: ["View", "Export"],
  },
  {
    id: 15,
    key: "customer-purchase-report",
    name: "Customer Purchase Report",
    module: "Customers",
    filters: ["Date", "Customer", "Country", "Seller"],
    columns: ["Customer", "Orders", "Units", "Gross Spend", "Refunds", "Net Spend", "Last Order"],
    actions: ["View profile", "Export"],
  },
  {
    id: 16,
    key: "customer-lifetime-value",
    name: "Customer Lifetime Value Report",
    module: "Customers",
    filters: ["Date range", "Country", "Customer segment"],
    columns: ["Customer", "Orders", "Gross Sales", "Refunds", "Net Sales", "Average Order", "Lifetime Value"],
    actions: ["Export"],
  },

  // Page 4: 17 to 24
  {
    id: 17,
    key: "customer-return-behaviour",
    name: "Customer Return Behaviour Report",
    module: "Customers",
    filters: ["Date", "Reason", "Customer"],
    columns: ["Customer", "Orders", "Returns", "Return Rate", "Refund Amount", "Replacement Count"],
    actions: ["Export"],
  },
  {
    id: 18,
    key: "wishlist-report",
    name: "Wishlist Report",
    module: "Customers",
    filters: ["Date", "Product", "Category", "Craft"],
    columns: ["Product", "Seller", "Wishlist Adds", "Removals", "Conversions"],
    actions: ["Export"],
  },
  {
    id: 19,
    key: "seller-master-report",
    name: "Seller Master Report",
    module: "Sellers",
    filters: ["Seller type", "Status", "State", "Craft", "Verification"],
    columns: ["Seller ID", "Store", "Type", "Craft", "Location", "KYC", "Status", "Products", "Sales"],
    actions: ["View seller", "Export"],
  },
  {
    id: 20,
    key: "seller-kyc-report",
    name: "Seller KYC Report",
    module: "Sellers",
    filters: ["Submission date", "Status", "Seller type"],
    columns: ["Seller", "Document Type", "Submitted", "Reviewer", "Status", "Expiry"],
    actions: ["Review", "Export"],
  },
  {
    id: 21,
    key: "seller-product-submission",
    name: "Seller Product Submission Report",
    module: "Sellers",
    filters: ["Date", "Seller", "Approval status", "Category"],
    columns: ["Product", "Seller", "Submitted", "Reviewer", "Status", "Rejection Reason"],
    actions: ["Review", "Export"],
  },
  {
    id: 22,
    key: "seller-sales-performance",
    name: "Seller Sales Performance Report",
    module: "Sellers",
    filters: ["Date", "Seller", "Category", "Craft"],
    columns: ["Seller", "Orders", "Units", "Gross Sales", "Returns", "Commission", "Payable", "Rating"],
    actions: ["Drill-down", "Export"],
  },
  {
    id: 23,
    key: "seller-settlement-report",
    name: "Seller Settlement Report",
    module: "Finance",
    filters: ["Period", "Seller", "Status"],
    columns: ["Seller", "Gross Sales", "Discounts", "Refunds", "Commission", "Adjustments", "Payable", "Paid"],
    actions: ["View settlement", "Export"],
  },
  {
    id: 24,
    key: "seller-payout-report",
    name: "Seller Payout Report",
    module: "Finance",
    filters: ["Date", "Seller", "Payout status"],
    columns: ["Payout ID", "Seller", "Settlement", "Bank", "Amount", "Reference", "Status", "Paid Date"],
    actions: ["View", "Export"],
  },

  // Page 5: 25 to 32
  {
    id: 25,
    key: "seller-commission-report",
    name: "Seller Commission Report",
    module: "Finance",
    filters: ["Date", "Seller", "Category", "Craft"],
    columns: ["Seller", "Order Item", "Base Amount", "Rate", "Commission", "Tax", "Status"],
    actions: ["Export"],
  },
  {
    id: 26,
    key: "seller-adjustment-report",
    name: "Seller Adjustment Report",
    module: "Finance",
    filters: ["Date", "Seller", "Adjustment type"],
    columns: ["Seller", "Reference", "Reason", "Debit/Credit", "Amount", "Status"],
    actions: ["View", "Export"],
  },
  {
    id: 27,
    key: "product-master-report",
    name: "Product Master Report",
    module: "Catalogue",
    filters: ["Category", "Craft", "Seller", "Status"],
    columns: ["Product ID", "Name", "SKU Count", "Seller", "Craft", "Price", "Status", "Approval"],
    actions: ["View", "Export"],
  },
  {
    id: 28,
    key: "sku-master-report",
    name: "SKU Master Report",
    module: "Catalogue",
    filters: ["Seller", "Product", "Category", "Status"],
    columns: ["SKU", "Product", "Variant", "Owner", "Barcode", "Weight", "Dimensions", "Price", "Status"],
    actions: ["View", "Export"],
  },
  {
    id: 29,
    key: "product-attribute-report",
    name: "Product Attribute Report",
    module: "Catalogue",
    filters: ["Category", "Craft", "Attribute"],
    columns: ["Product", "Attribute", "Value", "Unit", "Required", "Filterable"],
    actions: ["Export"],
  },
  {
    id: 30,
    key: "product-approval-report",
    name: "Product Approval Report",
    module: "Catalogue",
    filters: ["Date", "Reviewer", "Approval status", "Seller"],
    columns: ["Product", "Seller", "Submitted", "Reviewed", "Status", "Comments"],
    actions: ["Approve/reject", "Export"],
  },
  {
    id: 31,
    key: "product-rejection-report",
    name: "Product Rejection Report",
    module: "Catalogue",
    filters: ["Date", "Category", "Seller", "Reason"],
    columns: ["Product", "Seller", "Rejection Reason", "Reviewer", "Date"],
    actions: ["View", "Export"],
  },
  {
    id: 32,
    key: "category-product-report",
    name: "Category Product Report",
    module: "Catalogue",
    filters: ["Category", "Craft", "Seller", "Status"],
    columns: ["Category", "Craft", "Products", "Active", "Inactive", "Sales"],
    actions: ["Export"],
  },

  // Page 6: 33 to 40
  {
    id: 33,
    key: "inventory-stock-report",
    name: "Inventory Stock Report",
    module: "Inventory",
    filters: ["Warehouse", "Owner", "Seller", "Category", "Craft", "Stock status"],
    columns: ["SKU", "Product", "Owner", "Warehouse", "Available", "Reserved", "Transit", "QC", "Damaged", "Repair", "Rejected"],
    actions: ["View", "Export"],
  },
  {
    id: 34,
    key: "inventory-valuation-report",
    name: "Inventory Valuation Report",
    module: "Inventory",
    filters: ["Warehouse", "Owner", "Date", "Currency"],
    columns: ["SKU", "Quantity", "Cost", "Stock Value", "Selling Value", "Variance"],
    actions: ["Export"],
  },
  {
    id: 35,
    key: "low-stock-report",
    name: "Low Stock Report",
    module: "Inventory",
    filters: ["Warehouse", "Seller", "Reorder threshold"],
    columns: ["SKU", "Product", "Current Stock", "Reorder Level", "Shortage", "Owner"],
    actions: ["Create PO/task", "Export"],
  },
  {
    id: 36,
    key: "out-of-stock-report",
    name: "Out of Stock Report",
    module: "Inventory",
    filters: ["Seller", "Category", "Craft", "Warehouse"],
    columns: ["SKU", "Product", "Owner", "Warehouse", "Last Stock Movement"],
    actions: ["Export"],
  },
  {
    id: 37,
    key: "stock-movement-ledger",
    name: "Stock Movement Ledger Report",
    module: "Inventory",
    filters: ["Date", "SKU", "Warehouse", "Transaction type", "Owner"],
    columns: ["Date/Time", "SKU", "Warehouse", "Transaction", "Qty", "Previous", "New", "Reference", "User"],
    actions: ["View ledger", "Export"],
  },
  {
    id: 38,
    key: "stock-transfer-report",
    name: "Stock Transfer Report",
    module: "Inventory",
    filters: ["Date", "Source", "Destination", "Status"],
    columns: ["Transfer No", "Source", "Destination", "SKU", "Qty Dispatched", "Received", "Variance", "Status"],
    actions: ["View", "Export"],
  },
  {
    id: 39,
    key: "stock-adjustment-report",
    name: "Stock Adjustment Report",
    module: "Inventory",
    filters: ["Date", "Warehouse", "Reason", "Approver"],
    columns: ["Adjustment", "SKU", "Old Qty", "Adjustment", "New Qty", "Reason", "User", "Approval"],
    actions: ["Approve", "Export"],
  },
  {
    id: 40,
    key: "stock-count-reconciliation",
    name: "Stock Count / Reconciliation Report",
    module: "Inventory",
    filters: ["Count date", "Warehouse", "Status"],
    columns: ["Count No", "SKU", "System Qty", "Physical Qty", "Variance", "Reason", "Approval"],
    actions: ["View", "Export"],
  },

  // Page 7: 41 to 48
  {
    id: 41,
    key: "damage-report",
    name: "Damage Report",
    module: "Inventory",
    filters: ["Date", "Warehouse", "Seller", "Damage type", "Status"],
    columns: ["Damage ID", "SKU", "Qty", "Reason", "Evidence", "Cost", "Status", "Approver"],
    actions: ["View evidence", "Approve", "Export"],
  },
  {
    id: 42,
    key: "repair-job-report",
    name: "Repair Job Report",
    module: "Repair/QC",
    filters: ["Date", "Repair status", "Seller", "Repairer"],
    columns: ["Repair ID", "SKU", "Return", "Reason", "Parts", "Labour", "Shipping", "Total Cost", "Status"],
    actions: ["View", "Update", "Export"],
  },
  {
    id: 43,
    key: "qc-inspection-report",
    name: "QC Inspection Report",
    module: "Repair/QC",
    filters: ["Date", "Check type", "Status", "Warehouse"],
    columns: ["Reference", "SKU", "Checklist", "Result", "Remarks", "Checker", "Date"],
    actions: ["View", "Export"],
  },
  {
    id: 44,
    key: "rejected-stock-report",
    name: "Rejected Stock Report",
    module: "Inventory",
    filters: ["Date", "Warehouse", "Seller", "Reason"],
    columns: ["SKU", "Qty", "Reason", "Evidence", "Approved By", "Status"],
    actions: ["Export"],
  },
  {
    id: 45,
    key: "reservation-report",
    name: "Reservation Report",
    module: "Inventory",
    filters: ["Date", "SKU", "Warehouse", "Order"],
    columns: ["Reservation", "Order", "SKU", "Qty", "Reserved", "Released", "Status"],
    actions: ["View", "Export"],
  },
  {
    id: 46,
    key: "payment-collection-report",
    name: "Payment Collection Report",
    module: "Finance",
    filters: ["Date", "Gateway", "Currency", "Status"],
    columns: ["Order", "Transaction", "Gateway", "Amount", "Currency", "Status", "Paid Date"],
    actions: ["View", "Reconcile", "Export"],
  },
  {
    id: 47,
    key: "payment-failure-report",
    name: "Payment Failure Report",
    module: "Finance",
    filters: ["Date", "Gateway", "Reason"],
    columns: ["Order", "Customer", "Amount", "Gateway", "Failure Reason", "Attempts"],
    actions: ["Retry/view", "Export"],
  },
  {
    id: 48,
    key: "refund-report",
    name: "Refund Report",
    module: "Finance",
    filters: ["Date", "Refund status", "Seller", "Reason"],
    columns: ["Refund ID", "Order", "Return", "Amount", "Method", "Gateway Ref", "Status"],
    actions: ["View", "Export"],
  },

  // Page 8: 49 to 56
  {
    id: 49,
    key: "payment-reconciliation-report",
    name: "Payment Reconciliation Report",
    module: "Finance",
    filters: ["Period", "Gateway", "Status"],
    columns: ["Gateway", "Expected", "Received", "Variance", "Reconciled By", "Date"],
    actions: ["Reconcile", "Export"],
  },
  {
    id: 50,
    key: "tax-report",
    name: "Tax Report",
    module: "Finance",
    filters: ["Period", "Country", "State", "Tax type", "Seller"],
    columns: ["Taxable Sales", "Tax Collected", "Refunds", "Net Tax", "Seller"],
    actions: ["Export", "Print"],
  },
  {
    id: 51,
    key: "commission-report",
    name: "Commission Report",
    module: "Finance",
    filters: ["Period", "Seller", "Category", "Craft"],
    columns: ["Order Item", "Seller", "Base", "Rate", "Commission", "Tax", "Net"],
    actions: ["Export"],
  },
  {
    id: 52,
    key: "settlement-period-report",
    name: "Settlement Period Report",
    module: "Finance",
    filters: ["Period", "Status", "Seller"],
    columns: ["Period", "Seller", "Gross", "Refunds", "Commission", "Adjustments", "Payable", "Status"],
    actions: ["View", "Close", "Export"],
  },
  {
    id: 53,
    key: "profitability-report",
    name: "Profitability Report",
    module: "Finance",
    filters: ["Date", "Product", "SKU", "Seller", "Category"],
    columns: ["Revenue", "Product Cost", "Shipping Cost", "Commission", "Refunds", "Net Contribution"],
    actions: ["Export"],
  },
  {
    id: 54,
    key: "shipment-report",
    name: "Shipment Report",
    module: "Shipping",
    filters: ["Date", "Courier", "Seller", "Status", "Country"],
    columns: ["Shipment", "Order", "Seller", "Courier", "AWB", "Weight", "Cost", "Status", "Delivery"],
    actions: ["Track", "Export"],
  },
  {
    id: 55,
    key: "courier-performance-report",
    name: "Courier Performance Report",
    module: "Shipping",
    filters: ["Date", "Courier", "Country", "Service"],
    columns: ["Courier", "Shipments", "Delivered", "Delayed", "Failed", "Average Delivery Days", "Cost"],
    actions: ["Export"],
  },
  {
    id: 56,
    key: "delivery-delay-report",
    name: "Delivery Delay Report",
    module: "Shipping",
    filters: ["Date", "Courier", "Region", "Ageing"],
    columns: ["AWB", "Order", "Courier", "Promised Date", "Current Status", "Delay Days"],
    actions: ["Track", "Export"],
  },

  // Page 9: 57 to 64
  {
    id: 57,
    key: "shipping-cost-report",
    name: "Shipping Cost Report",
    module: "Shipping",
    filters: ["Date", "Seller", "Courier", "Country"],
    columns: ["Shipment", "Seller", "Courier", "Weight", "Shipping Charge", "Actual Cost", "Variance"],
    actions: ["Export"],
  },
  {
    id: 58,
    key: "international-customs-report",
    name: "International Customs Report",
    module: "Global Commerce",
    filters: ["Country", "Date", "Customs status", "Courier"],
    columns: ["Shipment", "Origin", "Destination", "HS Code", "Description", "Declared Value", "Customs Status"],
    actions: ["View", "Export"],
  },
  {
    id: 59,
    key: "shipping-restriction-report",
    name: "Shipping Restriction Report",
    module: "Global Commerce",
    filters: ["Country", "Category", "Material", "Status"],
    columns: ["Country", "Product Class", "Material", "Restriction Type", "Description"],
    actions: ["Export"],
  },
  {
    id: 60,
    key: "return-register",
    name: "Return Register",
    module: "After Sales",
    filters: ["Date", "Seller", "Reason", "Status"],
    columns: ["Return", "Order", "Customer", "Seller", "SKU", "Qty", "Reason", "Action", "Status"],
    actions: ["View", "Approve", "Export"],
  },
  {
    id: 61,
    key: "return-reason-analysis",
    name: "Return Reason Analysis",
    module: "After Sales",
    filters: ["Date", "Seller", "Category", "Reason"],
    columns: ["Reason", "Return Count", "Units", "Amount", "Percentage"],
    actions: ["Export"],
  },
  {
    id: 62,
    key: "replacement-report",
    name: "Replacement Report",
    module: "After Sales",
    filters: ["Date", "Seller", "Status"],
    columns: ["Replacement", "Original Order", "New SKU", "Seller", "Shipment", "Status"],
    actions: ["View", "Export"],
  },
  {
    id: 63,
    key: "exchange-report",
    name: "Exchange Report",
    module: "After Sales",
    filters: ["Date", "Seller", "Status"],
    columns: ["Exchange", "Old SKU", "New SKU", "Price Difference", "Status"],
    actions: ["View", "Export"],
  },
  {
    id: 64,
    key: "refund-vs-replacement",
    name: "Refund vs Replacement Report",
    module: "After Sales",
    filters: ["Date", "Seller", "Requested action"],
    columns: ["Action", "Count", "Amount", "Percentage", "Seller"],
    actions: ["Export"],
  },

  // Page 10: 65 to 72
  {
    id: 65,
    key: "repair-cost-report",
    name: "Repair Cost Report",
    module: "After Sales",
    filters: ["Date", "Seller", "Repairer", "Status"],
    columns: ["Repair", "SKU", "Parts", "Labour", "Shipping", "Total Cost", "Recovery"],
    actions: ["Export"],
  },
  {
    id: 66,
    key: "return-inspection-report",
    name: "Return Inspection Report",
    module: "After Sales",
    filters: ["Date", "Warehouse", "Condition"],
    columns: ["Return", "SKU", "Condition", "Inspection Result", "Evidence", "Disposition"],
    actions: ["View evidence", "Export"],
  },
  {
    id: 67,
    key: "review-rating-report",
    name: "Review & Rating Report",
    module: "Customer Experience",
    filters: ["Date", "Product", "Seller", "Rating"],
    columns: ["Product", "Seller", "Reviews", "Average Rating", "1-5 Star Distribution"],
    actions: ["View", "Export"],
  },
  {
    id: 68,
    key: "negative-review-report",
    name: "Negative Review Report",
    module: "Customer Experience",
    filters: ["Date", "Rating", "Seller", "Category"],
    columns: ["Product", "Seller", "Customer", "Rating", "Comment", "Status"],
    actions: ["Review", "Export"],
  },
  {
    id: 69,
    key: "product-qa-report",
    name: "Product Q&A Report",
    module: "Customer Experience",
    filters: ["Date", "Product", "Seller", "Status"],
    columns: ["Question", "Product", "Seller", "Customer", "Answer", "Status"],
    actions: ["View", "Respond", "Export"],
  },
  {
    id: 70,
    key: "artisan-craft-performance",
    name: "Artisan / Craft Performance Report",
    module: "Analytics",
    filters: ["Date", "Craft", "State", "Seller"],
    columns: ["Craft", "Artisans", "Products", "Sales", "Orders", "Rating", "Returns"],
    actions: ["Export"],
  },
  {
    id: 71,
    key: "geographic-performance",
    name: "Geographic Performance Report",
    module: "Analytics",
    filters: ["Country", "State", "District", "Date"],
    columns: ["Region", "Customers", "Orders", "Sales", "Returns", "Average Order"],
    actions: ["Export"],
  },
  {
    id: 72,
    key: "new-arrivals-performance",
    name: "New Arrivals Performance Report",
    module: "Analytics",
    filters: ["Date", "Collection", "Category"],
    columns: ["Product", "Launch Date", "Views", "Orders", "Units", "Sales", "Conversion"],
    actions: ["Export"],
  },

  // Page 11: 73 to 80
  {
    id: 73,
    key: "best-sellers-report",
    name: "Best Sellers Report",
    module: "Analytics",
    filters: ["Date", "Category", "Craft", "Seller"],
    columns: ["Product", "Seller", "Units", "Sales", "Rating", "Return Rate"],
    actions: ["Export"],
  },
  {
    id: 74,
    key: "slow-moving-product-report",
    name: "Slow Moving Product Report",
    module: "Analytics",
    filters: ["Date", "Category", "Seller", "Stock age"],
    columns: ["SKU", "Stock", "Days in Inventory", "Sales", "Value", "Owner"],
    actions: ["Export"],
  },
  {
    id: 75,
    key: "inventory-ageing-report",
    name: "Inventory Ageing Report",
    module: "Analytics",
    filters: ["Warehouse", "Seller", "Age bucket"],
    columns: ["SKU", "Received Date", "Quantity", "Stock Value", "Age Days", "Bucket"],
    actions: ["Export"],
  },
  {
    id: 76,
    key: "coupon-performance-report",
    name: "Coupon Performance Report",
    module: "Marketing",
    filters: ["Date", "Coupon", "Seller", "Category"],
    columns: ["Coupon", "Redemptions", "Orders", "Discount", "Sales", "ROI"],
    actions: ["Export"],
  },
  {
    id: 77,
    key: "promotion-performance-report",
    name: "Promotion Performance Report",
    module: "Marketing",
    filters: ["Date", "Promotion", "Category"],
    columns: ["Promotion", "Products", "Impressions", "Orders", "Sales", "Discount"],
    actions: ["Export"],
  },
  {
    id: 78,
    key: "notification-delivery-report",
    name: "Notification Delivery Report",
    module: "Communication",
    filters: ["Date", "Channel", "Event", "Status"],
    columns: ["Notification", "User", "Channel", "Provider", "Sent", "Delivered", "Failed"],
    actions: ["Retry", "Export"],
  },
  {
    id: 79,
    key: "support-ticket-report",
    name: "Support Ticket Report",
    module: "Support",
    filters: ["Date", "Priority", "Category", "Status", "Assignee"],
    columns: ["Ticket", "Customer/Seller", "Subject", "Priority", "Status", "Response Time", "Closure Time"],
    actions: ["View", "Assign", "Export"],
  },
  {
    id: 80,
    key: "admin-activity-audit-report",
    name: "Admin Activity / Audit Report",
    module: "Security",
    filters: ["Date", "Admin user", "Module", "Action"],
    columns: ["User", "Module", "Action", "Entity", "Old Value", "New Value", "IP", "Timestamp"],
    actions: ["View audit", "Export"],
  },

  // Page 12: 81 to 88
  {
    id: 81,
    key: "login-security-report",
    name: "Login & Security Report",
    module: "Security",
    filters: ["Date", "User", "Success/Failure", "IP"],
    columns: ["User", "Login Time", "Device", "IP", "Result", "Failure Reason"],
    actions: ["View", "Export"],
  },
  {
    id: 82,
    key: "api-usage-report",
    name: "API Usage Report",
    module: "System",
    filters: ["Date", "Client", "Endpoint", "Status"],
    columns: ["Client", "Endpoint", "Requests", "Errors", "Response Time", "Rate-limit Events"],
    actions: ["Export"],
  },
  {
    id: 83,
    key: "system-error-report",
    name: "System Error Report",
    module: "System",
    filters: ["Date", "Module", "Severity", "Status"],
    columns: ["Error ID", "Module", "Endpoint", "Severity", "Message", "Occurrence", "Resolution"],
    actions: ["View", "Resolve", "Export"],
  },
  {
    id: 84,
    key: "cms-content-report",
    name: "CMS Content Report",
    module: "CMS",
    filters: ["Content type", "Status", "Author", "Date"],
    columns: ["Page/Banner/FAQ", "Title", "Author", "Status", "Published", "Updated"],
    actions: ["Edit", "Publish", "Export"],
  },
  {
    id: 85,
    key: "seo-page-report",
    name: "SEO Page Report",
    module: "CMS/SEO",
    filters: ["Page type", "Index status", "Date"],
    columns: ["URL", "Title", "Meta Description", "Canonical", "Status", "Last Updated"],
    actions: ["Edit", "Export"],
  },
  {
    id: 86,
    key: "media-library-report",
    name: "Media Library Report",
    module: "CMS",
    filters: ["Media type", "Uploader", "Date"],
    columns: ["File", "Type", "Size", "Uploader", "Linked Entity", "Created"],
    actions: ["View", "Export"],
  },
  {
    id: 87,
    key: "master-data-report",
    name: "Master Data Report",
    module: "Masters",
    filters: ["Master type", "Status", "Country/Category/Craft"],
    columns: ["Code", "Name", "Parent", "Status", "Created", "Updated"],
    actions: ["View", "Export"],
  },
  {
    id: 88,
    key: "data-quality-missing-field",
    name: "Data Quality / Missing Field Report",
    module: "System",
    filters: ["Module", "Field", "Date", "Status"],
    columns: ["Entity", "Record", "Missing Field", "Severity", "Owner"],
    actions: ["View", "Export", "Fix"],
  },

  // Page 13: 89 to 89
  {
    id: 89,
    key: "backup-system-health-report",
    name: "Backup / System Health Report",
    module: "System",
    filters: ["Date", "Service", "Status"],
    columns: ["Service", "Backup Time", "Size", "Status", "Errors", "Last Successful Run"],
    actions: ["View", "Export"],
  },
];
